export default "__VITE_ASSET__CuHwFQuF__"